import {infiniteQueryOptions} from '@tanstack/react-query';
import {apiInstance} from '../../../api/api_Instance';
export const commentsApi = {
  getThreads: () => {
    return infiniteQueryOptions({
      queryKey: ['threads'],

      queryFn: (meta) =>
        apiInstance.get(`/threads/`, {
          params: {
            page: meta.pageParam,
          },
          signal: meta.signal,
        }),
      initialPageParam: 1,
      select: (result) => result.pages.flatMap((page) => page.data.results),
      getNextPageParam: (lastPage) => lastPage.data.next,
    });
  },
  getComments: () => {
    return infiniteQueryOptions({
      queryKey: ['comments'],
      queryFn: (meta) =>
        apiInstance.get(`/comments/`, {
          params: {
            page: meta.pageParam,
          },
          signal: meta.signal,
        }),
      initialPageParam: 1,
      select: (result) => result.pages.flatMap((page) => page.data.results),
      getNextPageParam: (lastPage) => lastPage.data.next,
    });
  },
};
